define([], () => ({
  RECEIVE_SUMOMEPRO_OPTIONS: 'RECEIVE_SUMOMEPRO_OPTIONS',
  ERROR_SUMOMEPRO_OPTIONS: 'ERROR_SUMOMEPRO_OPTIONS',

  SUMOME_UPSELL: 'SUMOME_UPSELL',
  UPDATE_APP_STORE_SETTING: 'UPDATE_APP_STORE_SETTING',
  SUMOME_UPSELL_LOADING: 'SUMOME_UPSELL_LOADING',

  RECEIVE_SUBSCRIPTION: 'RECEIVE_SUBSCRIPTION',

  SUMOME_OPEN_CONTACT_FORM: 'SUMOME_OPEN_CONTACT_FORM',

  RECEIVE_PRICING_TABLE: 'RECEIVE_PRICING_TABLE',

  SET_FEATURES: 'SET_FEATURES',

  UPDATE_SETTING: 'UPDATE_SETTING',
  SET_UPGRADE_PREVIEW: 'SET_UPGRADE_PREVIEW',
  SET_SHOW_UPGRADE: 'SET_SHOW_UPGRADE',
}));
